export default __webpack_public_path__ + "static/media/macd.1a467042.jpg";